import { validateEmail, validatePhone } from './graphQlSvc';

const LeadActions = {
    SET_EMAIL: 'SET_EMAIL',
    SET_EMAIL_VALIDATION: 'SET_EMAIL_VALIDATION',
    SET_TITLE_NAME: 'SET_TITLE_NAME',
    SET_FIRST_NAME: 'SET_FIRST_NAME',
    SET_FIRST_NAME_VALIDATION: 'SET_FIRST_NAME_VALIDATION',
    SET_LAST_NAME: 'SET_LAST_NAME',
    SET_LAST_NAME_VALIDATION: 'SET_LAST_NAME_VALIDATION',
    SET_LATIN_FIRST_NAME: 'SET_LATIN_FIRST_NAME',
    SET_LATIN_FIRST_NAME_VALIDATION: 'SET_LATIN_FIRST_NAME_VALIDATION',
    SET_LATIN_LAST_NAME: 'SET_LATIN_LAST_NAME',
    SET_LATIN_LAST_NAME_VALIDATION: 'SET_LATIN_LAST_NAME_VALIDATION',
    SET_PASSWORD: 'SET_PASSWORD',
    SET_PASSWORD_VALIDATION: 'SET_PASSWORD_VALIDATION',
    SET_PHONE_COUNTRY_CODE: 'SET_PHONE_COUNTRY_CODE',
    SET_PHONE_COUNTRY_CODE_DIGITS: 'SET_PHONE_COUNTRY_CODE_DIGITS',
    SET_PHONE_NUMBER: 'SET_PHONE_NUMBER',
    SET_PHONE_VALIDATION: 'SET_PHONE_VALIDATION',
    SET_JOIN_ID: 'SET_JOIN_ID',
    SET_PROPERTY_ID: 'SET_PROPERTY_ID',
    SET_ENTRY_TICKET_ID: 'SET_ENTRY_TICKET_ID',
    SET_AUTO_AUTH_URL: 'SET_AUTO_AUTH_URL',
    SET_PUBLIC_UUID: 'SET_PUBLIC_UUID',
    SET_NEW_SUPPLIER: 'SET_NEW_SUPPLIER',
    LEAD_CREATION_FAILED: 'LEAD_CREATION_FAILED',
    VALIDATE_EMAIL_START: 'VALIDATE_EMAIL_START',
    VALIDATE_EMAIL_SUCCESS: 'VALIDATE_EMAIL_SUCCESS',
    VALIDATE_EMAIL_FAIL: 'VALIDATE_EMAIL_FAIL',
    VALIDATE_PHONE_START: 'VALIDATE_PHONE_START',
    VALIDATE_PHONE_SUCCESS: 'VALIDATE_PHONE_SUCCESS',
    VALIDATE_PHONE_FAIL: 'VALIDATE_PHONE_FAIL',
    SET_MISSING_INFO: 'SET_MISSING_INFO',
    SET_MARKETING_EMAIL_SUBSCRIPTION: 'SET_MARKETING_EMAIL_SUBSCRIPTION',
    SET_WEBSITE: 'SET_WEBSITE',
    SET_WEBSITE_VALIDATION: 'SET_WEBSITE_VALIDATION',
    SET_ELIGIBILITY_STATUS: 'SET_ELIGIBILITY_STATUS',
    SET_USER_ID: 'SET_USER_ID',
    SET_IS_PAPER_CONTRACT_USER: 'SET_IS_PAPER_CONTRACT_USER',

    setIsPaperContractUser: (isPaperContractUser) => ({
        type: LeadActions.SET_IS_PAPER_CONTRACT_USER,
        isPaperContractUser
    }),

    setMarketingEmailSubscription: (isOptedOut) => ({
        type: LeadActions.SET_MARKETING_EMAIL_SUBSCRIPTION,
        isOptedOut,
        persist: true
    }),

    setEmail: (email) => ({
        type: LeadActions.SET_EMAIL,
        email,
        persist: true
    }),

    setEmailValidation: (result) => ({
        type: LeadActions.SET_EMAIL_VALIDATION,
        result
    }),

    setEmailValidationError: (error) => ({
        type: LeadActions.VALIDATE_EMAIL_FAIL, error
    }),

    validateEmail: (email, isDoubledValidation = false, isServerEmailValidationEnabled) => {
        const start = () => ({ type: LeadActions.VALIDATE_EMAIL_START });
        const success = (validationService) => ({
            type: LeadActions.VALIDATE_EMAIL_SUCCESS,
            validationService
        });
        const fail = (error) => ({ type: LeadActions.VALIDATE_EMAIL_FAIL, error });
        // eslint-disable-next-line max-len
        return validateEmail(email, isDoubledValidation, isServerEmailValidationEnabled, start, success, fail);
    },

    validatePhone: (phoneNumber) => {
        const start = () => ({ type: LeadActions.VALIDATE_PHONE_START, persist: true });
        const success = (validationService) => ({
            type: LeadActions.VALIDATE_PHONE_SUCCESS,
            validationService,
            persist: true
        });
        const fail = (error) => ({ type: LeadActions.VALIDATE_PHONE_FAIL, error, persist: true });
        return validatePhone(phoneNumber, start, success, fail);
    },

    setTitleName: (titleName) => ({
        type: LeadActions.SET_TITLE_NAME,
        titleName,
        persist: true
    }),

    setFirstName: (firstName) => ({
        type: LeadActions.SET_FIRST_NAME,
        firstName,
        persist: true
    }),

    setFirstNameValidation: (result) => ({
        type: LeadActions.SET_FIRST_NAME_VALIDATION,
        result
    }),

    setLastName: (lastName) => ({
        type: LeadActions.SET_LAST_NAME,
        lastName,
        persist: true
    }),

    setLastNameValidation: (result) => ({
        type: LeadActions.SET_LAST_NAME_VALIDATION,
        result
    }),

    setLatinFirstName: (latinFirstName) => ({
        type: LeadActions.SET_LATIN_FIRST_NAME,
        latinFirstName,
        persist: true
    }),

    setLatinFirstNameValidation: (result) => ({
        type: LeadActions.SET_LATIN_FIRST_NAME_VALIDATION,
        result
    }),

    setLatinLastName: (latinLastName) => ({
        type: LeadActions.SET_LATIN_LAST_NAME,
        latinLastName,
        persist: true
    }),

    setLatinLastNameValidation: (result) => ({
        type: LeadActions.SET_LATIN_LAST_NAME_VALIDATION,
        result
    }),

    setPassword: (password) => ({
        type: LeadActions.SET_PASSWORD,
        password,
        meta: {
            throttle: 200
        }
    }),

    setPasswordValidation: (result) => ({
        type: LeadActions.SET_PASSWORD_VALIDATION,
        result
    }),

    setPhoneCountryCode: (code) => ({
        type: LeadActions.SET_PHONE_COUNTRY_CODE,
        code,
        persist: true
    }),

    setPhoneCountryCodeDigits: (code) => ({
        type: LeadActions.SET_PHONE_COUNTRY_CODE_DIGITS,
        code,
        persist: true
    }),

    setPhoneNumber: (number) => ({
        type: LeadActions.SET_PHONE_NUMBER,
        number,
        persist: true
    }),

    setPhoneValidation: (result) => ({
        type: LeadActions.SET_PHONE_VALIDATION,
        result,
        persist: true
    }),

    setJoinId: (joinId) => ({
        type: LeadActions.SET_JOIN_ID,
        joinId
    }),
    setPropertyId: (propertyId) => ({
        type: LeadActions.SET_PROPERTY_ID,
        propertyId
    }),
    setUserId: (userId) => ({
        type: LeadActions.SET_USER_ID,
        userId,
        persist: true
    }),

    setEntryTicketId: (entryTicketId) => ({
        type: LeadActions.SET_ENTRY_TICKET_ID,
        entryTicketId
    }),

    setAutoAuthUrl: (autoAuthUrl) => ({
        type: LeadActions.SET_AUTO_AUTH_URL,
        autoAuthUrl
    }),

    setPublicUuid: (publicUuid) => ({
        type: LeadActions.SET_PUBLIC_UUID,
        publicUuid
    }),

    setNewSupplier: (newSupplier) => ({
        type: LeadActions.SET_NEW_SUPPLIER,
        newSupplier
    }),

    setLeadCreationError: (failed) => ({
        type: LeadActions.LEAD_CREATION_FAILED,
        failed
    }),
    setMissingInfo: (missingInfo) => ({
        type: LeadActions.SET_MISSING_INFO,
        missingInfo
    }),
    setWebsite: (website) => ({
        type: LeadActions.SET_WEBSITE,
        website,
        persist: true
    }),
    setWebsiteValidation: (result) => ({
        type: LeadActions.SET_WEBSITE_VALIDATION,
        result
    }),
    setEligibilityStatus: (reason) => ({
        type: LeadActions.SET_ELIGIBILITY_STATUS,
        reason
    })
};

export default LeadActions;
